module.exports = __webpack_public_path__ + "static/img/RAINFOREST-ALLIANCE-DESKTOP.5c760484.jpg";